import type React from "react"
import type { IconType } from "react-icons"

interface StatsCardProps {
  title: string
  value: number | string
  icon: IconType
  description: React.ReactNode
  gradient?: boolean
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon: Icon, description, gradient = true }) => {
  return gradient ? (
    <div className="bg-gradient-to-r from-[#2d53da] to-[#3d63ea] rounded-lg p-5 mb-6 text-white shadow-lg">
      <div className="flex items-center">
        <div className="bg-white/20 p-3 rounded-full mr-4">
          <Icon className="text-2xl" />
        </div>
        <div>
          <p className="text-white/80 text-sm">{title}</p>
          <h3 className="text-3xl font-bold">{value}</h3>
          {description && <p className="text-white/70 text-xs mt-1">{description}</p>}
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200 shadow-sm">
      <div className="flex items-center">
        <div className="bg-[#2d53da]/10 p-3 rounded-full mr-4">
          <Icon className="text-2xl text-[#2d53da]" />
        </div>
        <div>
          <p className="text-gray-500 text-sm">{title}</p>
          <h3 className="text-[1.175rem] font-bold text-gray-800">{value}</h3>
          {description && <p className="text-gray-400 text-xs mt-1">{description}</p>}
        </div>
      </div>
    </div>
  )
}

export default StatsCard
